//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ConfirmDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    afirmative: {
      type: Boolean,
      default: false,
    },
    borderClass: {
      type: String,
      default: "border-error",
    },
    icon: {
      type: String,
      default: "alert",
    },
    actOnChildrenText: {
      type: String,
      default: "",
    },
    hasChildrenOptions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actOnChildren: false,
    };
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    window.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        self.cancel();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("click", this.cancel);
  },
  methods: {
    cancel() {
      this.$close(false);
    },
    onClickOutside(e) {
      if (e.target === this.$refs.backdrop) {
        this.cancel();
      }
    },
  },
};
